import React, { useContext } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";
import apiRequest from "../../utils/apiRequest";

const useReviews = () => {
  const [contextData, builder] = useContext(VariantContextData);
  let variant = contextData.objects.variant;

  const Reviews = {
    create: async function (payload, callback) {
      apiRequest("POST", `/websites/${variant.website_id}/reviews`, {
        title: "New Review",
        ...(payload || {}),
      }, (data) => {
        callback(data);
      }, {'Accept': 'application/json' });
    },

    update: async function (payload, callback) {
      const response = await apiRequest("PUT_WITH_RESPONSE", `/websites/${variant.website_id}/reviews/${payload.id}`, payload);
      callback(response.json);
    },

    duplicate: async function (og_review, payload, skip_history) {
      let attributes = {
        rating: og_review.rating,
        title: og_review.title,
        content: og_review.content,
        customer_title: og_review.customer_title,
        customer_name: og_review.customer_name,
        customer_avatar: og_review.customer_avatar,
        brand_logo: og_review.brand_logo,
        video: og_review.video,
        date: og_review.date,
        options: og_review.options,
      };

      if (payload) {
        attributes = { ...attributes, ...payload };
      }

      builder.create("reviews", attributes, { skip_history: skip_history });
    },

    remove: (review) => {
      let message =
        "Are you sure you want to remove this review? Once your changes are saved, it will be irreversibly deleted.";

      builder.remove("reviews", review.id, message);
    },

    sortableStart: (element, review_recommendation) => {
      const targetObject = element || review_recommendation;
      if (!targetObject) return;

      const containerSelector = `.setting[data-object_type='elements'][data-object_id='${targetObject.id}'][data-setting_name='[options][reviews-ids]'] .cf-select-container`;

      let container = document.querySelector(containerSelector);
      let item_selector = ".select-multi-value";

      if (!container) return;

      let sortable_options = {
        sort: true,
        group: { name: containerSelector },
        animation: 0,
        draggable: item_selector,
        forceFallback: true,
        fallbackTolerance: 5,
        scrollSensitivity: 100,
        scrollSpeed: 10,
        onUpdate: (event) => {
          Reviews.sortableUpdate(event, targetObject);
        },
      };
      new Sortable(container, sortable_options);
    },

    sortableUpdate: (event, targetObject) => {
      let updates = [];
      let new_reviews_ids = [];

      Array.from(event.to.children).forEach((select_multi_value) => {
        const selectedOption = $(select_multi_value).find('div[data-value]')

        if (select_multi_value.classList.contains('select-multi-value') && selectedOption.length > 0) {
          new_reviews_ids.push(selectedOption.data('value'));
        }
      });

      const variant = contextData.objects.variant;
      const isReviewRecommendation = variant.review_recommendations && variant.review_recommendations[targetObject.id];
      const object_type = isReviewRecommendation ? "review_recommendations" : "elements";

      updates.push({
        object_type: object_type,
        object_id: targetObject.id,
        setting_name: "[options][reviews-ids]",
        value: new_reviews_ids.join(","),
      });

      builder.update(updates);
    },

    sortableContentStart: (element) => {
      const containerSelector = `.reviews-content[data-object_type="elements"][data-object_id='${element.id}']`;
      let container = document.querySelector(containerSelector);
      let item_selector =
        ".setting[data-setting_type='item_v2'][data-object_type='elements'][data-draggable='true']";

      let sortable_options = {
        sort: true,
        group: { name: containerSelector },
        animation: 0,
        draggable: item_selector,
        ghostClass: "drop-zone",
        handle: `.cf-item-v2[data-object_type='elements'][data-object-id='${element.id}']`,
        scroll: true,
        forceFallback: true,
        fallbackTolerance: 5,
        scrollSensitivity: 100,
        scrollSpeed: 10,
        setData: function (dataTransfer, dragEl) {
          dataTransfer.setData("Text", dragEl.textContent);
          let drag_image = document.getElementById("drag-image");
          dataTransfer.setDragImage(drag_image, 0, 0);
        },
        onUpdate: (event) => {
          let updates = [];

          Array.from(event.to.children).forEach((review_div, i) => {
            let new_position = i + 1;
            let setting_name = `[options]${review_div.getAttribute("data-setting_name")}`

            if (review_div.getAttribute("data-setting_type") == "item_v2") {
              updates.push({
                object_type: "elements",
                object_id: parseInt(review_div.getAttribute("data-object_id")),
                setting_name: setting_name,
                value: new_position,
              });
            }
          });

          builder.update(updates);
        },
      };
      new Sortable(container, sortable_options);
    },
  };

  let currentHook = Reviews;
  return { Reviews, currentHook };
};

export default useReviews;
